import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { type FormikProps } from 'formik'
import TextArea from 'legacy/components/Forms/TextArea'
import {
  type ProductFormValues,
  type NewProductFormValues,
} from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'

type Props = {} & (FormikProps<ProductFormValues> | FormikProps<NewProductFormValues>)

export const ProductDescription: FunctionComponent<Props> = ({ handleChange, values }) => {
  return (
    <FormSection titleId="catalog.product.description">
      <TextArea
        data-testid="product-description-textarea"
        name="details"
        value={values.details}
        onChange={handleChange}
        disabled={false}
        labelText={<FormattedMessage id="catalog.product.description" />}
      />
    </FormSection>
  )
}
